import { render, staticRenderFns } from "./FullSelectionPreviewCard.vue?vue&type=template&id=036fc1b8&scoped=true"
import script from "./FullSelectionPreviewCard.vue?vue&type=script&lang=ts"
export * from "./FullSelectionPreviewCard.vue?vue&type=script&lang=ts"
import style0 from "./FullSelectionPreviewCard.vue?vue&type=style&index=0&id=036fc1b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036fc1b8",
  null
  
)

export default component.exports